import {combineReducers, createStore} from "redux";

import userReducer from "./reducers/userReducer";
import uxReducer from "./reducers/uxReducer";

const reducers = combineReducers({ user : userReducer, uxReducer : uxReducer });

export default createStore(reducers)